import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { ImageUploadModule, SharedModule } from '../shared.module';
import { ConfirmModalComponent } from './component/confirm-modal/confirm-modal.component';
import { DynamicTableFormComponent } from './component/dynamic-table-form/dynamic-table-form.component';
import { FormDocComponent } from './component/form-doc/form-doc.component';
import { FormGeneratorComponent } from './component/form-generator/form-generator.component';
import { TableListComponent } from './component/table-list/table-list.component';
import { ConditionOperatorPipe } from './pipe/condtion-operator.pipe';
import { CurrencyFormatPipe } from './pipe/currency-format.pipe';
import { FormControlActionPipe } from './pipe/form-control-action.pipe';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { TransformArrayPipe } from './pipe/transform-array.pipe';
import { ButtonModule } from 'primeng/button';

@NgModule({
    declarations: [
        ConfirmModalComponent,
        FormGeneratorComponent,
        TableListComponent,
        ConditionOperatorPipe,
        TransformArrayPipe,
        FormControlActionPipe,
        DynamicTableFormComponent,
        FormDocComponent,
        CurrencyFormatPipe,
        SafeHtmlPipe
    ],
    providers: [ConditionOperatorPipe], exports: [FormGeneratorComponent, FormDocComponent, TableListComponent, ConditionOperatorPipe, DynamicTableFormComponent, CurrencyFormatPipe, SafeHtmlPipe],
    imports: [
        CommonModule,
        MultiSelectModule,
        TableModule,
        DropdownModule,
        AutoCompleteModule,
        ColorPickerModule,
        CalendarModule,
        FormsModule,
        ReactiveFormsModule,
        ImageUploadModule,
        ChipsModule,
        SharedModule,
        KeyFilterModule,
        PasswordModule,
        InputTextareaModule,
        CheckboxModule,
        RadioButtonModule,
        ButtonModule
    ]
})
export class FormHelperModule { }
